module.exports = "/fonts/vendor/quasar-extras/roboto-web-KFOlCnqEu92Fr1MmWUlfBBc-.woff?cf6613d1adf490972c557a8e318e0868";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/roboto-font/web-font/KFOlCnqEu92Fr1MmWUlfBBc-.woff
// module id = mreQ
// module chunks = 49